/** 海报使用原始清晰度，保留签名地址及水印等非缩放处理。 */
export const getPhotographyPosterImage = (source: string = '') => {
    if (!source || /^(?:data|blob):/i.test(source) || /[?&](?:Signature|x-oss-signature)=/i.test(source)) return source;
    return source.replace(/([?&]x-oss-process=)([^&#]*)/gi, (match, prefix, value) => {
        try {
            const process = decodeURIComponent(value);
            const fullSize = process.startsWith('image/')
                ? process.replace(/\/(?:resize|quality),[^/]+/g, '')
                : process.startsWith('video/snapshot,') ? process.replace(/,[wh]_\d+/g, '') : process;
            return fullSize === process ? match : `${prefix}${encodeURIComponent(fullSize)}`;
        } catch {
            return match;
        }
    });
};
